import React, { type PropsWithChildren } from 'react';
import { CarouselConsumer } from '..';
import { StyledCarouselSlide } from '../styled';

export const Slide = ({ children }: PropsWithChildren<{}>) => (
	<CarouselConsumer>{() => <StyledCarouselSlide>{children}</StyledCarouselSlide>}</CarouselConsumer>
);
